import React from 'react';

import { EventDetailTemplateWithButtons } from '../../components/common/template/EventDetailTemplate';
import * as IMAGE from '../../lib/image/event/EventMarketingAgreeImages';
import { MYPAGE_ACCOUNT } from '../../lib/routes/path';

const TITLE_MARKETINGAGREE = '베이비페이스 소식듣고 할인 받으세요';
const ID_MARKETINGAGREE = 'marketing-agree';
const PERIOD_MARKETINGAGREE = {
  startDate: '2022-11-14T00:00:00',
  endDate: '2022-12-31T23:59:59',
};

export const EVENT_DETAIL_MARKETINGAGREE = {
  title: TITLE_MARKETINGAGREE,
  period: PERIOD_MARKETINGAGREE,
  images: IMAGE.EVENT_DETAIL_MARKETINGAGREE,
  buttons: [
    {
      image: IMAGE.EVENT_DETAIL_MARKETINGAGREE_BUTTONS[0],
      position: { top: '62%' },
      event: { type: 'route', path: MYPAGE_ACCOUNT },
    },
  ],
};

export const EVENT_HOME_BANNER_MARKETINGAGREE = {
  id: ID_MARKETINGAGREE,
  period: PERIOD_MARKETINGAGREE,
  image: IMAGE.HOME_BANNER_MARKETINGAGREE,
};

export const EVENT_BANNER_MARKETINGAGREE = {
  id: ID_MARKETINGAGREE,
  period: PERIOD_MARKETINGAGREE,
  image: IMAGE.EVENT_BANNER_MARKETINGAGREE,
};

export const EVENT_COMPONENT_MARKETINGAGREE = {
  id: ID_MARKETINGAGREE,
  component: (
    <EventDetailTemplateWithButtons
      event={EVENT_DETAIL_MARKETINGAGREE}
      key={ID_MARKETINGAGREE}
    />
  ),
};
